<div class="m-[52px] mt-[93px] pb-[63px]">
  <!-- <div class="flex justify-start items-center">
    <img class="mr-[43px]" src="assets/icons/back-arrow.svg" alt="Back icon" />
    <h3 class="title">Expression Of Interest</h3>
  </div> -->
  <!-- <div class="w-[100%] flex justify-end mb-[6px] mt-[106px] mr-[8px]"></div> -->
  <div class="flex justify-end mr-[83px]">
    <button class="print-button">Print</button>
  </div>
  <div class="container mt-[40px]">
    <div class="flex justify-between items-center mx-[20px] mt-[40px]">
      <div class="flex flex-col items-end">
        <h3 class="title">Expression Of Interest</h3>
      </div>
      <div class="flex items-center gap-[18px]">
        <img
          src="assets/images/logo.png"
          alt="logo"
          class="h-[78px] w-[78px] rounded-[7px]"
        />
      </div>
    </div>

    <div class="mx-[43px] mt-[51px]">
      <!-- applicant detail -->

      <div class="flex justify-start items-center !mt-5">
        <h4 class="applicant-detail">Applicant Details</h4>
        <img
          src="assets/icons/pencil.svg"
          alt="pencil"
          class="ml-[10px] cursor-pointer"
        />
      </div>
      <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
        <div class="flex flex-col">
          <p class="header-attribute">Company Name</p>
          <p class="header-attribute-value">
            {{ expressionData?.company_name }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Contact Person</p>
          <p class="header-attribute-value">
            {{ expressionData?.contact_person }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Company Registration Number</p>
          <p class="header-attribute-value">
            {{ expressionData?.company_reg_no }}
          </p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">Position</p>
          <p class="header-attribute-value">
            {{ expressionData?.contact_person_position }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">VAT Registration Number</p>
          <p class="header-attribute-value">
            {{ expressionData?.company_vat_no }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Email</p>
          <p class="header-attribute-value">{{ expressionData?.email }}</p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">Website</p>
          <p class="header-attribute-value">{{ expressionData?.website }}</p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Telephone</p>
          <p class="header-attribute-value">+1 (555) 123-4567</p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Address</p>
          <p class="header-attribute-value">{{ expressionData?.address }}</p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">City</p>
          <p class="header-attribute-value">{{ expressionData?.city }}</p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Country</p>
          <p class="header-attribute-value">
            {{ expressionData?.country_name ?? "United States" }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">State/Province</p>
          <p class="header-attribute-value">{{ expressionData?.state }}</p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">Zip Code</p>
          <p class="header-attribute-value">{{ expressionData?.zip }}</p>
        </div>
        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>

      <!-- scope of interest -->

      <div class="flex justify-start items-center mt-[36px]">
        <h4 class="applicant-detail">Scope of Interest</h4>
        <img
          src="assets/icons/pencil.svg"
          alt="pencil"
          class="ml-[10px] cursor-pointer"
        />
      </div>
      <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
        <div class="flex flex-col">
          <p class="header-attribute">Nature of service Required</p>
          <p class="header-attribute-value">
            {{ expressionData?.nature_of_service }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Type of Project</p>
          <p class="header-attribute-value">
            {{ expressionData?.type_of_project ?? "Building" }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Project location</p>
          <p class="header-attribute-value">
            {{ expressionData?.project_location ?? "New york" }}
          </p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">Estimation Project value</p>
          <p class="header-attribute-value">
            {{ expressionData?.estimation_price }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Expected Start Date</p>
          <p class="header-attribute-value">
            {{ expressionData?.expected_start_date | date : "yyyy-MM-dd" }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Expected End Date</p>
          <p class="header-attribute-value">
            {{ expressionData?.expected_end_date | date : "yyyy-MM-dd" }}
          </p>
        </div>

        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>

      <!-- Experience & Capability (If Applicable) -->

      <div class="flex justify-start items-center mt-[36px]">
        <h4 class="applicant-detail">
          Experience & Capability(If Applicable) 
        </h4>
        <img
          src="assets/icons/pencil.svg"
          alt="pencil"
          class="ml-[10px] cursor-pointer"
        />
      </div>
      <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
        <div class="flex flex-col">
          <p class="header-attribute">Relevant Experience</p>
          <p class="header-attribute-value">
            {{ expressionData?.experience }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Key Qualifications</p>
          <p class="header-attribute-value">
            {{ expressionData?.qualifications }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Team Composition</p>
          <p class="header-attribute-value">
            {{ expressionData?.team_composition }}
          </p>
        </div>

        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>

      <!--  Compliance & Policies -->

      <div class="flex justify-start items-center mt-[36px]">
        <h4 class="applicant-detail">Compliance & Policies</h4>
        <img
          src="assets/icons/pencil.svg"
          alt="pencil"
          class="ml-[10px] cursor-pointer"
        />
      </div>
      <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
        <div class="flex flex-col">
          <p class="header-attribute">Health, Safety & Environmental Policy</p>
          <p class="header-attribute-value">
            {{ expressionData?.health_safety_environmental_policy }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Quality Assurance Certification</p>
          <p class="header-attribute-value">
            {{ expressionData?.quality_assurance_cert_attach }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Conflict of Interest Disclosure</p>
          <p class="header-attribute-value">
            {{ expressionData?.conflict_of_interest }}
          </p>
        </div>

        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>

      <!--  Additional Information -->

      <div class="flex justify-start items-center mt-[36px]">
        <h4 class="applicant-detail">Additional Information</h4>
        <img
          src="assets/icons/pencil.svg"
          alt="pencil"
          class="ml-[10px] cursor-pointer"
        />
      </div>
      <p class="header-attribute-value" style="margin-top: 20px !important">
        {{ expressionData?.description }}
      </p>

      <!--   Declaration -->

      <div class="flex justify-start items-center mt-[36px]">
        <h4 class="applicant-detail">Declaration</h4>
        <img
          src="assets/icons/pencil.svg"
          alt="pencil"
          class="ml-[10px] cursor-pointer"
        />
      </div>
      <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px] mb-[40px]">
        <div class="flex flex-col">
          <p class="header-attribute">Name of Authorized Representative</p>
          <p class="header-attribute-value">
            {{ expressionData?.authorized_representative }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Position</p>
          <p class="header-attribute-value">
            {{ expressionData?.authorized_representative_position }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Signature</p>
          <p class="header-attribute-value">{{ expressionData?.signature }}</p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Date</p>
          <p class="header-attribute-value">
            {{ expressionData?.date | date : "yyyy-MM-dd" }}
          </p>
        </div>

        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div>

<!-- Dialog content -->
<ng-template #dialogTemplate class="w-[100%]">
  <h2 mat-dialog-title>Print Preview</h2>
  <mat-dialog-content>
    <div>eofjseofielfin</div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeDialog()" class="mr-[30px]">Close</button>
    <button (click)="print()" class="print-button">Print</button>
  </mat-dialog-actions>
</ng-template>
